import { styled } from '../stitches.config';
export const ShortcutKey = styled('span', {
    px: '$1',
    py: '$0.5',
    fontSize: '$sm',
    lineHeight: '$sm',
    color: '$gray-400',
    border: '1px solid $gray-300',
    borderRadius: '$md',
});
//# sourceMappingURL=shortcut-key.js.map